module.exports = __webpack_public_path__ + "img/pt2.574eb021.png";